'use client';
import Dashboard from "@/components/pages/dashboard";
import { DashboardLinks } from "@/components/pages/dashboard/constants";
import React, { useEffect } from "react";
import WhereIsMyOrder from "@/components/pages/dashboard/pages/where-is-my-order";
import { useCartConfig } from "@/providers/cart-config/CartConfigContext";
import { useRouter } from 'next/navigation';
import { useLocale } from 'next-intl';
const WhereIsMyOrderTastic = () => {
    const locale = useLocale();
    const router = useRouter();
    const { isCartEnabled, isLoading } = useCartConfig();
    useEffect(() => {
        if (!isLoading && !isCartEnabled) {
            router.push(`/${locale}/`);
        }
    }, [isCartEnabled, isLoading, router, locale]);
    return (
        <Dashboard href={DashboardLinks.whereIsMyOrder}>
            <WhereIsMyOrder />
        </Dashboard>
    )
}

export default WhereIsMyOrderTastic